import styled from 'styled-components'
import { media } from '@popety-io/ui'

export const HeaderContainer = styled.div`
  background: ${({ theme }) => theme.colors.background.primary};
  border-bottom: 1px solid ${({ theme }) => theme.colors.border.default};
  padding: ${({ theme }) => theme.spacing.small}
    ${({ theme }) => theme.spacing.default};

  ${media.tabletDown} {
    padding: ${({ theme }) => theme.spacing.small}
      ${({ theme }) => theme.spacing.medium};
  }
`

export const HeaderContent = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: ${({ theme }) => theme.spacing.large};

  ${media.tabletDown} {
    flex-direction: column;
    gap: 2px;
  }
`

export const PropertyInfo = styled.div`
  display: flex;
  align-items: flex-start;
  gap: ${({ theme }) => theme.spacing.medium};
  flex: 1;

  ${media.tabletDown} {
    gap: ${({ theme }) => theme.spacing.small};
  }
`

export const RadarContainer = styled.div`
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: -6px;
  margin-bottom: -6px;

  ${media.tabletDown} {
    margin: 0;
    transform: scale(0.6);
    transform-origin: top left;
    margin-right: -32px;
    margin-bottom: -16px;
  }
`

export const PropertyDetails = styled.div`
  flex: 1;
  min-width: 0;
`

export const PropertyTitle = styled.h1`
  font-size: 20px;
  font-weight: ${({ theme }) => theme.typography.fontWeight.semibold};
  color: ${({ theme }) => theme.colors.text.primary};
  margin: 0;

  ${media.tabletDown} {
    font-size: ${({ theme }) => theme.typography.fontSize.title};
  }
`

export const PropertyMeta = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing.small};
  flex-wrap: wrap;

  ${media.tabletDown} {
    gap: ${({ theme }) => theme.spacing.xsmall};
  }
`

export const MetaItem = styled.span`
  color: ${({ theme }) => theme.colors.text.secondary};
  font-size: ${({ theme }) => theme.typography.fontSize.body};
  font-weight: ${({ theme }) => theme.typography.fontWeight.semibold};

  ${media.tabletDown} {
    font-size: ${({ theme }) => theme.typography.fontSize.label};
  }
`

export const MetaDivider = styled.span`
  color: ${({ theme }) => theme.colors.border.default};
  margin: 0 ${({ theme }) => theme.spacing.xsmall};

  &::before {
    content: '•';
  }

  ${media.tabletDown} {
    margin: 0 2px;
  }
`

export const PropertyActions = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.medium};
  align-items: flex-end;

  ${media.tabletDown} {
    flex-direction: row;
    align-items: center;
    width: 100%;
  }
`

export const ActionGroup = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.spacing.small};
  padding-top: ${({ theme }) => theme.spacing.small};

  ${media.tabletDown} {
    padding-top: 0;
    flex-wrap: wrap;
  }
`
